import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { ImportScheduleErrorProps } from '../types';
import { AddImportScheduleError } from '@bechtel/types';

const getErrorMessage = (error: ImportScheduleErrorProps['error']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case AddImportScheduleError.SCHEDULE_ALREADY_EXIST:
      return <Trans>Schedule already exist for selected date.</Trans>;
    case AddImportScheduleError.INVALID_SCHEDULE_DATETIME:
      return <Trans>Invalid Schedule date and time.</Trans>;
    case AddImportScheduleError.ERROR_SCHEDULING_IMPORT:
      return <Trans>Error while workpackage schedule import</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

export const ImportWpScheduleError: FC<ImportScheduleErrorProps> = ({ error, close }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} style={{ width: '400px', height: '275px' }}>
      <ModalHeader title={t`Import Schedule Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(error)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans>Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
